document.addEventListener(
  "DOMContentLoaded",
  function() {
    if (
      window.location.href.indexOf("localhost") &&
      window.location.port == 3000
    ) {
      var links = Array.from(document.getElementsByTagName("a"));
      links.forEach(function(link) {
        link.setAttribute(
          "href",
          (link.getAttribute("href") || "").replace(
            "localhost",
            "localhost:3000"
          )
        );
      });
    }
  },
  false
);



//////////////////
// WEBPACK FOOTER
// ./src/js/index.js
// module id = 1
// module chunks = 0